import adaptiveCue2026 from './AdaptiveCue_2026/AdaptiveCue_2026';
import cityGaze2026 from './CityGaze_2026/CityGaze_2026';
import thingMoji2025 from './ThingMoji_2025/ThingMoji_2025';
import debateGenAI2025 from './DebateGenAI_2025/DebateGenAI_2025';

const projects = [
  adaptiveCue2026,
  cityGaze2026,
  thingMoji2025,
  debateGenAI2025,
];

export default projects;
